import React, { useState } from "react";
import ToastContext from "./ToastContext";
import ToastPortal from "./ToastPortal";
var ToastProvider = _ref => {
  var {
    children
  } = _ref;
  var [activeToast, setActiveToast] = useState(null);
  var [requestClose, setRequestClose] = useState(null);
  var removeToast = () => {
    activeToast == null || activeToast.onClose == null || activeToast.onClose();
    setActiveToast(null);
  };
  var addToast = newToast => {
    if (activeToast) {
      setRequestClose(() => () => {
        removeToast();
        setRequestClose(null);
        setActiveToast(newToast);
      });
    } else {
      setActiveToast(newToast);
    }
  };
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: {
      addToast,
      removeToast
    }
  }, children, activeToast && /*#__PURE__*/React.createElement(ToastPortal, {
    activeToast: activeToast,
    requestClose: requestClose
  }));
};
export default ToastProvider;